"use client";

import { Carousel } from "@material-tailwind/react";
import Image from "next/image";
import { useState, useEffect } from "react";

import admin from "../../../../public/images/oldsite/admin1-1.jpg"

export default function GalCaru() {

    const [stickyClass, setStickyClass] = useState(' mt-0');

    useEffect(() => {
      window.addEventListener('scroll', stickNavbar);
  
      return () => {
        window.removeEventListener('scroll', stickNavbar);
      };
    }, []);
  
    const stickNavbar = () => {
      if (window !== undefined) {
        let windowHeight = window.scrollY;
        windowHeight > 110 ? setStickyClass(' mt-[60px]') : setStickyClass(' mt-0');
      }
    };


  return (
    <Carousel
      className={`relative h-[300px] md:h-[500px]  lg:h-[90vh] overflow-hidden ${stickyClass}`}
      navigation={({ setActiveIndex, activeIndex, length }) => (
        <div className="absolute bottom-4 left-2/4 z-50 flex -translate-x-2/4 gap-2">
          {new Array(length).fill("").map((_, i) => (
            <span
              key={i}
              className={`block h-1 cursor-pointer rounded-2xl transition-all content-[''] ${
                activeIndex === i ? "w-8 bg-white" : "w-4 bg-white/50"
              }`}
              onClick={() => setActiveIndex(i)}
            />
          ))}
        </div>
      )}
    >
      <div className="relative h-[300px] md:h-[500px] lg:h-[90vh]">
      <video className="h-full object-cover object-center" height="100%" width="100%" src="./images/gallery/factory/factory2-3_1080_crop.mp4"  autoPlay muted playsInline loop>
        {/* <source src="./images/gallery/factory/factory3-2.MOV" type="video/mov"> */}
      </video>
      <div className="absolute bottom-0 left-0 w-full h-full bg-chimia-950/20"></div>
      <div className="absolute bottom-0 left-0 w-full h-full flex flex-col items-center justify-center">
              <h1 className="font-extrabold text-lg md:text-4xl text-white lg:text-6xl">CHIMIART FACTORY</h1>
      </div>

      </div>

      <div className="relative h-[300px] md:h-[500px] lg:h-[90vh]">
      <video className="h-full object-cover object-center" height="100%" width="100%" src="./images/gallery/factory/factory3-2_720.mp4"  autoPlay muted playsInline loop>
        {/* <source src="./images/gallery/factory/factory3-2.MOV" type="video/mov"> */}
      </video>
      <div className="absolute bottom-0 left-0 w-full h-full bg-chimia-950/30"></div>
      <div className="absolute bottom-0 left-0 w-full h-full flex flex-col items-center justify-center">
              <h1 className="font-extrabold text-lg md:text-4xl text-white lg:text-6xl text-shadow drop-shadow-2xl">CHIMIART WAREHOUSE</h1>
      </div>

      </div>



      <div className="relative h-[300px] md:h-[500px] lg:h-[90vh]">
      <Image
        src={admin}
        fill
        alt="adminstration office HQ of chimiart egypt for chemical industries "
        className="h-full w-full max-h-[100vh] object-cover object-center"
      />
      <div className="absolute bottom-0 left-0 w-full h-full bg-chimia-950/60"></div>
      <div className="absolute top-0 left-0 w-full h-1/2 flex flex-col items-center justify-center">
              <h1 className="font-extrabold text-lg md:text-4xl text-white lg:text-6xl text-shadow drop-shadow-2xl">CHIMIART ADMINSTRATION </h1>
      </div>

      </div>
     
      
    
    </Carousel>
  );
}